import React, { useState } from "react";
import "./Contact.scss";
import EM from "../../assets/icons/email.png";
import PH from "../../assets/icons/phone.png";
import MP from "../../assets/icons/map.png";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

const initialFormState = {
  fName: "",
  lName: "",
  priPhone: "",
  altPhone: "",
  email: "",
  message: "",
};

export default function Contact() {
  const [contactForm, setContactForm] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  function objectToFormData(obj) {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      formData.append(key, value);
    });

    return formData;
  }

  function validateForm(values) {
    const nextErrors = {};

    if (!values.fName.trim()) nextErrors.fName = "* First Name is required";
    if (!values.lName.trim()) nextErrors.lName = "* Last Name is required";
    if (!values.email.trim()) nextErrors.email = "* Email Address is required";
    if (!values.priPhone.trim()) nextErrors.priPhone = "* Phone Number is required";
    if (!values.message.trim()) nextErrors.message = "* Message is required";

    return nextErrors;
  }

  const onSubmit = (event) => {
    event.preventDefault();

    const nextErrors = validateForm(contactForm);
    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      return;
    }

    const data = {
      FirstName: contactForm.fName,
      LastName: contactForm.lName,
      PrimaryPhoneNumber: contactForm.priPhone,
      AlternatePhoneNumber: contactForm.altPhone,
      Email: contactForm.email,
      Message: contactForm.message,
    };
    const fData = objectToFormData(data);
    fetch(
      "https://script.google.com/macros/s/AKfycbzK8-0HjaNvFl1gw49EOAac1y1QbdzoNELoR9FRzrAuvf6NYS-e0L50cyFjkAyXRUk6ig/exec",
      {
        method: "POST",
        body: fData,
      }
    )
      .then((res) => {
        if (res.ok) {
          setContactForm(initialFormState);
          setErrors({});
          alert("Data send successfully!");
        }
      })
      .catch((err) => console.log("err", err));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setContactForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
    <Breadcrumb />
      <div className="contactUsBase">
        <div className="contactUsContent">
          <div className="contactLeft">
            <div className="leftContactContent">
              <h1 className="contactTitleTxt">Contact Now</h1>
              <div className="contactDetailsDiv">
                <div className="contactIconDiv">
                  <img src={EM} alt="contact" className="contactIcon" />
                </div>
                <p className="contactDetailsTxt">
                  richard.restorationroofing@gmail.com
                </p>
              </div>
              <div className="contactDetailsDiv">
                <div className="contactIconDiv">
                  <img src={MP} alt="contact" className="contactIcon" />
                </div>
                <h2 className="contactDetailsTxt">
                  6902 FM2920, Suite 2, <br />
                  Spring, TX 77379
                </h2>
              </div>
              <div className="contactDetailsDiv">
                <div className="contactIconDiv">
                  <img src={PH} alt="contact" className="contactIcon" />
                </div>
                <p className="contactDetailsTxt">(832) 388-5393</p>
              </div>

              <button className="whiteBtnFF">Working Hours</button>

              <p className="contactDetailsTxtF">
                Monday-Friday -
                <span className="contactDetailsTxtSpan">9:00 AM -5:00 PM</span>
              </p>
              <p className="contactDetailsTxtF">
                Saturday -
                <span className="contactDetailsTxtSpan">
                  By Appointment Only
                </span>
              </p>

              <div className="gMapDiv">
                <a
                  rel="noreferrer"
                  href="https://www.google.com/maps/place/Restoration+Roofing+%26+Remodeling+LLC,+6902+Farm+to+Market+2920+Suite+2,+Spring,+TX+77379,+United+States/@30.0748763,-95.5279994,17z/data=!4m6!3m5!1s0x8647337550c94b33:0x7e7a7b98d49ddbdc!8m2!3d30.0748763!4d-95.5279994!16s%2Fg%2F11ft3fg6cc"
                  target="_blank"
                >
                  <iframe
                    title="Restoration Roofing location map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4095.5547639744736!2d-95.5279994!3d30.0748763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8647337550c94b33%3A0x7e7a7b98d49ddbdc!2sRestoration%20Roofing%20%26%20Remodeling%20LLC!5e1!3m2!1sen!2sin!4v1785323780372!5m2!1sen!2sin"
                    width="600"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="contactRight">
            <div className="rightContactContent">
              <form className="form" onSubmit={onSubmit}>
                <div className="formTop">
                  <p className="formTitle">We’ve got you covered</p>
                </div>
                <div className="formContent">
                  <div className="formContentTop">
                    <div className="field_area">
                      <div>
                        <input
                          type="text"
                          id="fName"
                          name="fName"
                          placeholder="First Name"
                          className="textField"
                          value={contactForm.fName}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.fName && <div className="error">{errors.fName}</div>}
                    </div>
                    <div className="field_area">
                      <div>
                        <input
                          type="text"
                          id="lName"
                          placeholder="Last Name"
                          name="lName"
                          className="textField"
                          value={contactForm.lName}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.lName && <div className="error">{errors.lName}</div>}
                    </div>
                  </div>
                  <div className="formContentTop">
                    <div className="field_area">
                      <div>
                        <input
                          type="text"
                          id="priPhone"
                          name="priPhone"
                          placeholder="Primary Phone"
                          className="textField"
                          value={contactForm.priPhone}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.priPhone && (
                        <div className="error">{errors.priPhone}</div>
                      )}
                    </div>
                    <div className="field_area">
                      <div>
                        <input
                          type="text"
                          id="altPhone"
                          name="altPhone"
                          placeholder="Alternate Phone"
                          className="textField"
                          value={contactForm.altPhone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="field_area">
                    <div>
                      <input
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Email Address"
                        className="textField"
                        value={contactForm.email}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.email && <div className="error">{errors.email}</div>}
                  </div>
                  <div className="formContentBottom">
                    <div className="field_area">
                      <div>
                        <textarea
                          placeholder="Your Comments"
                          className="textArea"
                          name="message"
                          rows="5"
                          value={contactForm.message}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.message && (
                        <div className="error">{errors.message}</div>
                      )}
                    </div>
                    <div className="formBtnDiv">
                      <button type="submit" className="submitBtn">
                        SUBMIT
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
